import React from "react";
import Films from "../../components/Films/Films";

function NowShowing() {
  return <Films type="now_playing" />;
}

export default NowShowing;
